// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".referral-code[data-v-10f87ee4] {\n  display: inline-block;\n  padding: 5px 10px;\n  background-color: #F0F0F0;\n  border: 1px solid #a0a0a0;\n}\n", ""]);
// Exports
module.exports = exports;
